"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comment = exports.breach = exports.userSearch = exports.autocomplete = exports.addRule = exports.confirm = exports.getComments = exports.getAll = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var base = "".concat(process.env.REACT_APP_SHERLOCK_URL, "/api/breach");
var baseComment = "".concat(process.env.REACT_APP_SHERLOCK_URL, "/api/comment");
var rule = "".concat(process.env.REACT_APP_SHERLOCK_URL, "/api/rule/createWeb");
var token = tokenStorage_1.default.get();
function getAll(filters, order, orderBy, skip) {
    if (order === void 0) { order = 'DESC'; }
    if (orderBy === void 0) { orderBy = 'created_at'; }
    return api_1.default
        .post("".concat(base, "/list"), tslib_1.__assign(tslib_1.__assign({}, filters), { skip: skip, order: order, orderBy: orderBy }))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getAll = getAll;
function getComments(expertId) {
    return api_1.default.get("".concat(baseComment, "?expertId=").concat(expertId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getComments = getComments;
function confirm(id, status) {
    return api_1.default.put("".concat(base), { id: id, confirmed: status }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.confirm = confirm;
function addRule(data) {
    var instance = axios_1.default.create({
        headers: {
            authorization: "Bearer ".concat(token),
        },
    });
    return instance.post("".concat(rule), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.addRule = addRule;
function autocomplete(keyword) {
    return api_1.default.get("/api/expert/typeahead-search?q=".concat(keyword)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.autocomplete = autocomplete;
function userSearch(keyword) {
    return api_1.default.get("/api/employee/typeahead?q=".concat(keyword)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.userSearch = userSearch;
function breach(data) {
    return api_1.default.post(base, data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.breach = breach;
function comment(data) {
    return api_1.default.post(baseComment, data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.comment = comment;
var api = {
    getAll: getAll,
    confirm: confirm,
    autocomplete: autocomplete,
    userSearch: userSearch,
    breach: breach,
    comment: comment,
    getComments: getComments,
    addRule: addRule,
};
exports.default = api;
